/* eslint-disable */
import React from 'react';
import { Divider, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useGetApplication } from '~/controllers/wizard';
import styled from 'styled-components';

import { CheckCircleOutlined, CheckOutlined } from '@ant-design/icons';
import InitialInformation from '~/components/InitialInformation';
import BusinessDetails from '~/pages/ksa/application/reviewAndSubmit/Elements/BusinessDetails';
import { useDirection } from '~/hooks/i18nHooks';
import { useGetServices } from '~/controllers/pricing';

function ApplicationSummary(props: any) {
  const applicationQuery = useGetApplication();
  const servicesQuery = useGetServices();
  const servicesData = servicesQuery.data?.services || [];
  const { t } = useTranslation('ksaApplication');
  const payload: any = applicationQuery.data?.payload;
  const services: any = Object?.entries(payload?.services || {})?.filter(([key, value]: any) => {
    return (
      value?.enabled || (key === 'nGeniusONEPayByLink' && payload?.services?.eCommerce?.enabled)
    );
  });
  const dir = useDirection();
  const tradeIssuingAuthority = payload?.review?.companyLicense?.issuingAuthorityLabel;
  const servicesImages: any = {
    eCommerce: '/img/ServicesECOM.jpg',
    nGeniusGo: '/img/ServicesSoftPOS.jpg',
    nGeniusONEPayByLink: '/img/PayByLink.jpg',
    nGeniusONEPayByQR: '/img/ServicesSoftPOS.jpg',
    nGeniusPos: '/img/ServicesPOSNew.png',
    // New API key for POS terminal
    POS: '/img/ServicesPOSNew.jpg',
  };
  return (
    <Container dir={dir}>
      <Typography.Paragraph className="summaryTitle">{t('Summary')}</Typography.Paragraph>
      <Typography.Paragraph className="selectedProductsText">
        {t('Selected Products')}
      </Typography.Paragraph>
      {services?.map(([key, value]: any) => {
        const serviceItem = servicesData.find((s: any) => s.key === key);
        const imageUrl = serviceItem?.imageUrl || servicesImages[key];
        let displayTitle = '';
        if (key === 'eCommerce') {
          displayTitle = t('E-commerce');
        }
        else if (key === 'POS') {
          displayTitle = t('POS Terminal');
        }
        else if (serviceItem) {
          displayTitle = t(serviceItem.header) || t(serviceItem.name);
        }

        return (
          <ServicesList key={key} dir={dir}>
            <img className="servicesImage" src={imageUrl} alt={key} />
            <ServiceInfo>
              <Typography.Paragraph className="servicesTitleText">{displayTitle}</Typography.Paragraph>
              {key !== 'eCommerce' && key !== 'nGeniusONEPayByLink' && (
                <Typography.Paragraph className="servicesQtyText">
                  {t('Qty')}: {value?.terminals ?? value?.terminalFee ?? 1}
                </Typography.Paragraph>
              )}
            </ServiceInfo>
          </ServicesList>
        );
      })}
      {payload && Object.keys(payload).length > 2 && <Divider />}
      <InitialInformation data={applicationQuery?.data?.payload} />
    </Container>
  );
}

const DocumentUploaded = styled.div`
  .checkDocs {
    font-size: 14px;
    color: #0069b1;
    margin-right: 8px;
  }
`;

const Container = styled.div<any>`
  display: flex;
  flex-direction: column;
  padding: 24px;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 2px 6px 0px rgba(0, 89, 150, 0.03), 0px -1px 8px -10px rgba(0, 89, 150, 0.03);
  // margin-top: 40px;
  width: 100%;
  max-width: 380px;
  .secondryFont {
    color: #000;
    margin-top: 0;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 171.429% */
  }
  .summaryTitle {
    color: #000;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 40px;
    margin-bottom:0px !important;
  }
  .selectedProductsText {
    margin-top: 24px;
    margin-bottom: 8px;
    color: #4a4a4a;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.14px;
  }
`;
const ServicesList = styled.div<any>`
  position: relative;
  width: 100%;
  border-radius: 8px;
  margin-top: 8px;
  border: 1px solid #c2dbec;
  background: #fff;
  display: flex;
  flex-direction: row;
  height: 80px;
  align-items: center;
  .servicesImage {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: ${({ dir }) => (dir === 'rtl' ? '0 8px 8px 0' : '8px 0 0 8px')};
  }
  .servicesQtyText {
    color: #4a4a4a;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 16px; /* 133.333% */
    letter-spacing: 0.24px;
    margin: 0;
  }
  .servicesTitleText {
    color: #000;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */
    margin: 0 0 4px 0;
  }
`;
const ServiceInfo = styled.div`
  padding: 16px;
`;

export default ApplicationSummary;
